export default "__VITE_ASSET__DsYEU16G__"